var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_28",
    "data-name": "Group 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 105.162,
    height: 105.162,
    viewBox: "0 0 105.162 105.162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "user-img-clip"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 105.162,
    height: 105.162,
    fill: "#e761a0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    clipPath: "url(#user-img-clip)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M89.761,15.4A52.581,52.581,0,1,0,15.4,89.761,52.581,52.581,0,1,0,89.761,15.4m-37.18,8.546A18.834,18.834,0,1,1,33.747,42.781,18.834,18.834,0,0,1,52.581,23.947M84.413,88.02a47.57,47.57,0,0,1-63.663,0V83.557A17.832,17.832,0,0,1,38.581,65.726h28A17.832,17.832,0,0,1,84.413,83.557Z",
    fill: "#e761a0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserImg);
export default __webpack_public_path__ + "static/media/userImg.d568536e9e965f2b91e70b1e6a95fd40.svg";
export { ForwardRef as ReactComponent };